import { useCallback, useEffect, useState } from 'react';

export const useListIntersectionObserver = (
  listItems: HTMLElement[],
  { threshold = 0, root = null, rootMargin = '0%' }: IntersectionObserverInit,
): IntersectionObserverEntry | undefined => {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();
  const handleIntersection = useCallback((entries: IntersectionObserverEntry[]): void => {
    entries.forEach(_entry => {
      if (_entry.isIntersecting) {
        setEntry(_entry);
      }
    });
  }, []);

  useEffect(() => {
    const hasIOSupport = !!window.IntersectionObserver;

    if (!hasIOSupport) {
      return;
    }

    const observerParameters = { threshold, root, rootMargin };
    const intersectionObserver = new IntersectionObserver(handleIntersection, observerParameters);

    listItems.forEach(listItem => {
      intersectionObserver.observe(listItem);
    });

    return () => {
      listItems.forEach(listItem => {
        intersectionObserver.unobserve(listItem);
      });
    };
  }, [handleIntersection, listItems, root, rootMargin, threshold]);

  return entry;
};
